import { VLayout } from '@sleepstation/components-layouts'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import TitledScoreChart from './TitledScoreChart'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const CHART_COLORS = [`#c790ad`, `#af608a`, `#880E4F`]
const ANXIETY_CHART_LABELS = [`None`, null, `Severe`]
const DEPRESSION_CHART_LABELS = [`None-mild`, null, `Severe`]
const STRESS_CHART_LABELS = [`None-mild`, null, `Severe`]

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  spacing: [2, 3, 4],
})``

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const Charts = ({ anxietyScale, depressionScale, stressScale }) => (
  <Layout>
    <TitledScoreChart
      dataCy={`anxiety-score-chart`}
      {...anxietyScale}
      colors={CHART_COLORS}
      labels={ANXIETY_CHART_LABELS}
    />
    <TitledScoreChart
      dataCy={`depression-score-chart`}
      {...depressionScale}
      colors={CHART_COLORS}
      labels={DEPRESSION_CHART_LABELS}
    />
    <TitledScoreChart
      dataCy={`stress-score-chart`}
      {...stressScale}
      colors={CHART_COLORS}
      labels={STRESS_CHART_LABELS}
    />
  </Layout>
)

Charts.propTypes = {
  anxietyScale: PropTypes.object.isRequired,
  depressionScale: PropTypes.object.isRequired,
  stressScale: PropTypes.object.isRequired,
}

Charts.defaultProps = {}

export default Charts
